"use client";

import { IProductTilePriceAndBrandNameXP } from "@faire/web-api--source/indigofair/data/IProductTilePriceAndBrandNameXP";
import React from "react";

import { useSettingPriceFirstAndNewBrandLink } from "@faire/retailer/settings/useSettingPriceFirstAndNewBrandLink";

export const MaybeNewBrandLinkWrapper: React.FC<{
  oldBrandInfoComponent: React.ReactNode;
  newBrandInfoComponent: React.ReactNode;
}> = ({ newBrandInfoComponent, oldBrandInfoComponent }) => {
  const showNewBrandLink =
    useSettingPriceFirstAndNewBrandLink() ===
    IProductTilePriceAndBrandNameXP.Bucket.NEW_BRAND_LINK;

  if (showNewBrandLink) {
    return <>{newBrandInfoComponent}</>;
  }
  return <>{oldBrandInfoComponent}</>;
};
